declare namespace $ {

	export class $mol_email extends $mol_string {
		type( ): string
		keyboard( ): string
		hint( ): string
	}
	
}

//# sourceMappingURL=email.view.tree.d.ts.map